// import { Fetcher } from './fetcher';

// function composeSearchedPosts( posts ) {
//     let layout = '';

//     if ( Array.isArray( posts ) ) {
//         posts.forEach( ( { title, image, link } ) => {
//             layout += `<a href="${ link }">
//                             ${ image ? `<div class="product__image">${ image }</div>` : '' }
//                             <h2 class="product__title">${ title }</h2>
//                         </a>`;
//         } );
//     } else {
//         layout = `<p class="no-result">${ posts }</p>`;
//     }

//     return layout;
// }

// function composeSearchedTerms( terms ) {
//     let layout = '';

//     if ( Array.isArray( terms ) ) {
//         terms.forEach( ( { title, link } ) => {
//             layout += `<a href="${ link }">${ title }</a>`;
//         } );
//     } else {
//         layout = `<p class="no-result">${ terms }</p>`;
//     }

//     return layout;
// }

// function renderSearchedItems( data, { modal, search_input_container, post_output, terms_output } ) {
//     if ( data.error ) {
//         post_output.innerHTML  = data.error;
//         terms_output.innerHTML = data.error;
//     } else {
//         post_output.innerHTML  = composeSearchedPosts( data.posts );
//         terms_output.innerHTML = composeSearchedTerms( data.terms );
//     }

//     modal.classList.add( 'show' );
//     document.body.classList.add( 'overflow' );
//     search_input_container.classList.remove( 'active' );

//     showBack( modal );
// }

// function showModal( modal ) {
//     modal.classList.add( 'show' );
//     document.body.classList.add( 'overflow' );
//     showBack( modal );
// }

// // Show back btn on mobile menu
// function showBack( modal ) {
//     if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
//         return
//     }

//     const back_btn = document.querySelector( '#header .btn--back' );

//     if ( back_btn ) {
//         back_btn.dataset.close = `#${ modal.id }`;
//         back_btn.classList.add( 'show' );
//         back_btn.addEventListener( 'click', () => {
//             back_btn.classList.remove( 'show' );
//         } );
//     }
// }

// function hideModal( modal, time = 500 ) {
//     return setTimeout( () => {
//         modal.classList.remove( 'show' );
//         document.body.classList.remove( 'overflow' );
//     }, time );
// }

// function handleError( error, { search_input_container } ) {
//     console.error( error );

//     search_input_container.classList.remove( 'active' );
// }

// function updateViewport() {
//     document.documentElement.style.setProperty( '--viewport', window.innerHeight + 'px' );
//     requestAnimationFrame( updateViewport );
// }

// window.addEventListener( 'load', () => {
//     const search_form              = document.querySelector( '#search-form' ),
//           search_input             = search_form.querySelector( '#search' ),
//           search_input_container   = search_input.parentElement,
//           search_modal             = document.querySelector( '#search-results-modal' ),
//           search_results_container = search_modal.querySelector( '.search__results' ),
//           post_output              = search_modal.querySelector( '.products__results' ),
//           terms_output             = search_modal.querySelector( '.terms__results' ),
//           fetch_items              = new Fetcher(
//               '/wp-json/custom/search',
//               renderSearchedItems,
//               {
//                   modal                 : search_modal,
//                   search_input_container: search_input_container,
//                   post_output           : post_output,
//                   terms_output          : terms_output
//               },
//               handleError,
//               {
//                   search_input_container: search_input_container
//               }
//           );
//     let searchTimeout              = null,
//         modal_hide                 = null,
//         modal_hovered              = false,
//         input_has_focus            = false;

//     if ( search_input ) {
//         search_input.addEventListener( 'keyup', () => {
//             // Clear timout if user didn't finish entering value
//             clearTimeout( searchTimeout );

//             // Start searching when user enters more than 3 letters
//             if ( search_input.value.length <= 3 ) {
//                 return;
//             }

//             // Set throttling to wait when use finishes typing
//             searchTimeout = setTimeout( () => {
//                 fetch_items.parameters = fetch_items.composeParameters( [ [ 's', search_input.value ] ] );
//                 fetch_items.GET();
//                 search_input_container.classList.add( 'active' );
//             }, 350 );
//         } );

//         // Show modal on input focus if modal not empty
//         search_input.addEventListener( 'focus', () => {
//             input_has_focus = true;

//             clearTimeout( modal_hide );
//             if ( post_output.childElementCount || terms_output.childElementCount ) {
//                 showModal( search_modal );
//             }
//         } );

//         if ( window.matchMedia( '(min-width: 992px)' ).matches ) {

//             // Hide modal when input not on focus
//             search_input.addEventListener( 'blur', () => {
//                 input_has_focus = false;

//                 if ( modal_hovered ) {
//                     return;
//                 }

//                 modal_hide = hideModal( search_modal );
//             } );

//             search_results_container.addEventListener( 'mouseenter', () => {
//                 clearTimeout( modal_hide );
//                 modal_hovered = true;
//             } );

//             search_results_container.addEventListener( 'mouseleave', () => {
//                 if ( !input_has_focus ) {
//                     modal_hide = hideModal( search_modal );
//                 }
//                 modal_hovered = false;
//             } );
//         } else {
//             window.requestAnimationFrame( updateViewport );
//         }
//     }
// } );

export default class Search {
	constructor(section_node) {
		this.search_wrapper = section_node.querySelector("#search-wrapper");
		this.search_form = section_node.querySelector("#search-form");
		this.modal_show = section_node.querySelector("#search-title");
		this.search_input = this.search_form.querySelector("#search-input");
		this.search_results = this.search_wrapper.querySelector("#search-results");
		this.search_results_mobile =
			this.search_wrapper.querySelector("#search-results");
		this.reset_button = this.search_wrapper.querySelector("#reset_input");
		this.magnifier = this.search_wrapper.querySelector("#magnifier");
		this.modal_hide = this.search_form.querySelector("#close-btn");
		this.mobile_query = window.matchMedia("max-width: 991px");
		this.base_url = "/wp-json/custom/search/";
		this.searchTimeout = null;
		this.paramsString = "";
	}
	init() {
		//abort if no wrapper or form
		if (!this.search_wrapper || !this.search_form) return;

		//prevent form submit
		if (this.search_form) {
			this.search_form.addEventListener("submit", (e) => {
				e.preventDefault();
			});
		}

		//open search
		if (this.modal_show && this.search_wrapper) {
			this.modal_show.addEventListener("click", () => {
				this.search_wrapper.classList.add("show");
				this.search_input.focus();
			});
		}

		//close search
		if (this.modal_hide && this.search_wrapper) {
			this.modal_hide.addEventListener("click", () => {
				this.search_wrapper.classList.remove("show");
				this.search_results.innerHTML = "";
			});
		}

		//reset input
		if (this.reset_button && this.search_input) {
			this.reset_button.addEventListener("click", () => {
				this.search_input.value = "";
				this.search_results.innerHTML = "";
				this.reset_button.classList.remove("show");
				this.magnifier && this.magnifier.classList.add("show");
				this.search_results_mobile.classList.remove("show");
			});
		}

		if (this.search_input) {
			this.search_input.addEventListener("keyup", (e) => {
				// Clear timout if user didn't finish entering value
				clearTimeout(this.searchTimeout);

				if (this.search_input.value.length == 0) {
					this.search_results.innerHTML = "";
					this.search_results_mobile.innerHTML = "";
					this.magnifier && this.magnifier.classList.add("show");
					this.search_results_mobile.classList.remove("show");
					document.querySelector(
						".mobile-header .navbar-nav"
					).style.visibility = "unset";
					this.reset_button && this.reset_button.classList.remove("show");
					return;
				} else if (this.search_input.value.length <= 2) {
					return;
				} else if (this.mobile_query && this.search_input.value.length >= 3) {
					document.querySelector(
						".mobile-header .navbar-nav"
					).style.visibility = "hidden";
					this.search_results_mobile.classList.add("show");
				}
				// Set throttling to wait when use finishes typing
				this.searchTimeout = setTimeout(() => {
					this.composeSearchParameters();
					// fetch_items.parameters = fetch_items.composeParameters( [ [ 's', search_input.value ] ] );
					// fetch_items.GET();
					// search_input_container.classList.add( 'active' );

					fetch(this.base_url + this.paramsString)
						.then((result) => result.json())
						.then((response) => {
							console.log(response);
							this.search_results.innerHTML = "";
							this.renderSearchResults(response);
							this.reset_button && this.reset_button.classList.add("show");
							this.magnifier && this.magnifier.classList.remove("show");
							console.log(this.base_url + this.paramsString);
						})
						.catch((error) => {
							console.error("There has been an error: ", error);
						});
				}, 100);
			});
		}
	}

	renderSearchResults(data) {
		Object.entries(data).forEach((term) => {
			if (term[0] == "error") {
				const html_layout = this.composeEmptyResults(term[1]);
				this.search_results.insertAdjacentHTML("beforeend", html_layout);
				return;
			}
			if (Array.isArray(term[1])) {
				const html_layout = this.composeSearchResults(term[0], term[1]);
				this.search_results.insertAdjacentHTML("beforeend", html_layout);
			} else if (typeof (term[1] == "object") && term[1] != null) {
				this.renderSearchResults(term[1]);
			} else return;
		});
	}

	composeEmptyResults(error) {
		let layout = ``;
		layout += `<span class="no-results">${error}</span>`;
		return layout;
	}

	composeSearchResults(title, posts) {
		let layout = ``;
		layout += `<span class="search-title">${title}</span><ul>`;
		posts.forEach((post) => {
			layout += `<li><a href="${post.link}">${post.title}</a></li>`;
		});
		layout += `</ul>`;
		return layout;
	}

	composeSearchParameters() {
		const inputs = this.search_form.querySelectorAll("input");
		const search_terms = {};
		this.paramsString = "";
		for (let input of inputs) {
			search_terms[input.name] = input.value;
		}

		Object.entries(search_terms).forEach((term, key) => {
			if (key == 0) {
				this.paramsString += "?";
			} else {
				this.paramsString += "&";
			}
			this.paramsString += `${term[0]}=${term[1]}`;
		});
	}
}

// window.addEventListener("load", () => {
// 	const search_wrapper = document.querySelector("#search-wrapper"),
// 		search_form = document.querySelector("#search-form"),
// 		search_input = search_form.querySelector("#search-input"),
// 		search_results = search_wrapper.querySelector("#search-results"),
// 		modal_show = document.querySelector("#search-title"),
// 		modal_hide = search_form.querySelector("#close-btn"),
// 		base_url = "/wp-json/custom/search/";

// 	let searchTimeout = null;

// 	//abort if no wrapper or form
// 	if (!search_wrapper || !search_form) return;

// 	//open search
// 	if (modal_show && search_wrapper) {
// 		modal_show.addEventListener("click", () => {
// 			search_wrapper.classList.add("show");
// 		});
// 	}

// 	//close search
// 	if (modal_hide && search_wrapper) {
// 		modal_hide.addEventListener("click", () => {
// 			search_wrapper.classList.remove("show");
// 		});
// 	}

// 	//prevent form submit
// 	if (search_form) {
// 		search_form.addEventListener("submit", (e) => {
// 			e.preventDefault();
// 		});
// 	}

// 	if (search_input) {
// 		search_input.addEventListener("keyup", () => {
// 			// Clear timout if user didn't finish entering value
// 			clearTimeout(searchTimeout);

// 			// Start searching when user enters more than 3 letters
// 			if (search_input.value.length <= 3) {
// 				return;
// 			}

// 			// Set throttling to wait when use finishes typing
// 			searchTimeout = setTimeout(() => {
// 				let params = composeSearchParameters(search_form);
// 				// fetch_items.parameters = fetch_items.composeParameters( [ [ 's', search_input.value ] ] );
// 				// fetch_items.GET();
// 				// search_input_container.classList.add( 'active' );
// 				console.log(params);

// 				fetch(base_url + params)
// 					.then((result) => result.json())
// 					.then((response) => {
// 						console.log(response);
// 					})
// 					.catch((error) => {
// 						console.error("There has been an error: ", error);
// 					});
// 			}, 350);
// 		});
// 	}
// });

function composeSearchResults(data) {}

function composeSearchParameters(form) {
	const inputs = form.querySelectorAll("input");
	const search_terms = {};
	for (let input of inputs) {
		search_terms[input.name] = input.value;
	}

	let paramsString = "";

	Object.entries(search_terms).forEach((term, key) => {
		if (key == 0) {
			paramsString += "?";
		} else {
			paramsString += "&";
		}
		paramsString += `${term[0]}=${term[1]}`;
	});

	return paramsString;
}
